import React, { useState } from "react";

const testimonials = [
  { name:"Sita Sharma", location:"Kathmandu", avatar:"👩", plan:"Hospital Cash", review:"Sajilo Policy le mero jivan sajilo banayo! Rs 99/week maa hospital cash coverage paunu sachhai amazing cha. Highly recommend!", rating:5 },
  { name:"Ram Bahadur Thapa", location:"Pokhara", avatar:"👨", plan:"Personal Accident", review:"I had an accident last year and the claim process was so smooth. Got my money within 3 days. Best insurance platform in Nepal!", rating:5 },
  { name:"Anita Gurung", location:"Biratnagar", avatar:"👩‍💼", plan:"Travel Insurance", review:"Traveled to Thailand with Sajilo Policy travel insurance. Flight was delayed and I got compensated. Worth every paisa!", rating:5 },
  { name:"Bikash Rai", location:"Dharan", avatar:"🧑", plan:"Bike & Scooter", review:"Finally an insurance company that doesn't require 100 documents. Bought bike insurance in 2 minutes. Unbelievable!", rating:5 },
  { name:"Priya Shrestha", location:"Lalitpur", avatar:"👩‍🎓", plan:"Student Accident", review:"As a student, Rs 99/week insurance is a lifesaver. My parents are so relieved. Thank you Sajilo Policy!", rating:5 },
  { name:"Dipesh Karki", location:"Chitwan", avatar:"👨‍🌾", plan:"Crop Protection", review:"Barsha le mero bali barbad garyo tara Sajilo Policy le claim diyera mero ghar chalyo. Himalayan Life Insurance ko support ma dhanyabad!", rating:5 },
];

function Testimonials() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="testimonials" style={{padding:"80px 48px", background:"#f0fdfa"}}>
      <div style={{textAlign:"center", marginBottom:"56px"}}>
        <h2 style={{fontSize:"40px", fontWeight:"900", color:"#0f172a", marginBottom:"12px"}}>
          What <span style={{background:"linear-gradient(135deg, #0d9488, #0891b2)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent"}}>Nepalis</span> Say
        </h2>
        <p style={{fontSize:"16px", color:"#64748b"}}>Real stories from real customers across Nepal 🇳🇵</p>
      </div>
      <div style={{display:"flex", gap:"24px", justifyContent:"center", flexWrap:"wrap"}}>
        {testimonials.map((t, i) => (
          <div key={i}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
            style={{background:"#fff", border: hovered === i ? "2px solid #0d9488" : "2px solid #e2e8f0", borderRadius:"20px", padding:"28px", width:"300px", transition:"all 0.3s", transform: hovered === i ? "translateY(-8px)" : "translateY(0)", boxShadow: hovered === i ? "0 20px 48px rgba(13,148,136,0.12)" : "0 4px 16px rgba(0,0,0,0.04)"}}>
            <div style={{display:"flex", gap:"4px", marginBottom:"16px"}}>
              {"★★★★★".split("").map((star, j) => (
                <span key={j} style={{color:"#0d9488", fontSize:"16px"}}>{star}</span>
              ))}
            </div>
            <p style={{color:"#374151", fontSize:"14px", lineHeight:"1.8", marginBottom:"20px", fontStyle:"italic"}}>"{t.review}"</p>
            <div style={{display:"flex", alignItems:"center", gap:"12px", paddingTop:"16px", borderTop:"1px solid #f1f5f9"}}>
              <span style={{fontSize:"32px"}}>{t.avatar}</span>
              <div>
                <div style={{color:"#0f172a", fontWeight:"700", fontSize:"14px"}}>{t.name}</div>
                <div style={{color:"#64748b", fontSize:"12px"}}>{t.location}</div>
                <div style={{color:"#0d9488", fontSize:"11px", fontWeight:"700", marginTop:"2px"}}>{t.plan}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;